import { render, staticRenderFns } from "./ProfileHome.vue?vue&type=template&id=510c6e59&scoped=true&"
import script from "./ProfileHome.vue?vue&type=script&lang=js&"
export * from "./ProfileHome.vue?vue&type=script&lang=js&"
import style0 from "./ProfileHome.vue?vue&type=style&index=0&id=510c6e59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c6e59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('510c6e59', component.options)
    } else {
      api.reload('510c6e59', component.options)
    }
    module.hot.accept("./ProfileHome.vue?vue&type=template&id=510c6e59&scoped=true&", function () {
      api.rerender('510c6e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/home/ProfileHome.vue"
export default component.exports